module.exports = __webpack_public_path__ + "img/NL347.bfed2446.png";